import { Layout, Row, Space } from 'antd';
import { SideMenu } from './components/SideMenu';
import 'rapidoc';
import React, { useEffect, useState } from 'react';
import './App.less';
import { Logo } from './components/Logo';
import { brandName } from './helpers/brand-helper';
import { BrowserRouter as Router, Switch, Redirect, Route } from 'react-router-dom';
import { Home } from './components/Home';
import { Changelogs } from './components/Changelogs';
import { API } from './components/API';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { CHANGELOG_LIST } from './changelog-list';
import Hotjar from '@hotjar/browser';

const { Header, Content, Sider } = Layout;

const DEV_DOC_ORIGINS = ['http://localhost:3000', 'https://docs.dev.pclocs.io', 'https://docs.dev.lockncharge.io'];

const App = (): JSX.Element => {
  const [isCollapsed, setCollapsed] = useState<boolean>(false);
  const [originChangelogTag, setOriginChangelogTag] = useState<number>();

  const devHotjarSiteId = 3160953;
  const prodHotjarSiteId = 3160947;

  const siteId = ['docs.pclocs.io', 'docs.lockncharge.io'].some((v) => v === window.location.hostname)
    ? prodHotjarSiteId
    : devHotjarSiteId;
  const hotjarVersion = 6;

  Hotjar.init(siteId, hotjarVersion);

  useEffect(() => {
    document.title = `${brandName()} Cloud Documentation`;

    function handleMessage(event: MessageEvent) {
      // allow local portal to retrieve changelogs from dev docs
      const isEventOriginLocal =
        event.origin === 'http://localhost:4200' && DEV_DOC_ORIGINS.includes(window.location.origin);

      if ((!isEventOriginLocal && window.location.origin.replace(/docs\./, '') !== event.origin) || !event.data) {
        return;
      }

      setOriginChangelogTag(event.data);
      const latestChangelogTag = Math.max(...CHANGELOG_LIST.map((v) => v.tagId));
      (event.source as Window).postMessage(latestChangelogTag, event.origin);
    }
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return originChangelogTag ? (
    <Changelogs targetTag={originChangelogTag} />
  ) : (
    <Router>
      <Layout>
        <Header className="header-nav">
          <Logo />
          <Space>Documentation</Space>
        </Header>
        <Layout hasSider>
          <Sider
            className="side-menu"
            trigger={isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            theme="light"
            breakpoint="lg"
            collapsible
            collapsedWidth="0"
            width={220}
            onCollapse={(collapsed) => {
              setCollapsed(collapsed);
            }}
          >
            <SideMenu />
          </Sider>
          <Content className="main-content" style={{ marginLeft: isCollapsed ? 0 : 220 }}>
            <Switch>
              <Route exact path="/">
                <Home />
              </Route>
              <Route path="/changelogs">
                <Changelogs />
              </Route>
              <Route path="/api">
                <Row>
                  <API />
                </Row>
              </Route>
              <Route render={() => <Redirect to="/" />} />
            </Switch>
          </Content>
        </Layout>
      </Layout>
    </Router>
  );
};

export default App;
